import copy from 'clipboard-copy';
import axios from 'axios';
import React, { useEffect, useRef, useState } from "react";
import ReactDOMServer from 'react-dom/server';

import { QRCodeSVG } from 'qrcode.react';
// import { QRCode } from 'react-qr-svg';
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import Toast from "../components/Toast";
// import logo from "../components/images/GymLogo.png";
import logo from "../components/images/Easy-MembrLogo.png";
import { getGBussinessInfo, getWaiverSettingsbyGymid, updateLocation, getLocation, updateWaiverSettings, getPaymentLinkSetting, reqConfirmPaymentStatus, getMultiGymsAndPlans, getGlobalPlanAccess, getPinelabsSettings, savePinelabsSettings } from "../services/apiServices.js";
import BusinessPage from "./BusinessPage";
import BussinessHours from "./BussinessHours.js";
import PaymentMethods from "./PaymentMethods.js";
import TaxSettings from "./TaxSettings";
import WaiverSettings from "./waiverSettings.js";
import { getEADeviceSettings, toggleEADevice, regenerateEAKey, updateEADeviceSettings } from "../services/apiServices.js";
import TimezoneSelect from 'react-timezone-select';

import {
  MDBAlert,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBChip,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow
} from 'mdb-react-ui-kit';
import PageError from './PageError';
import GeoLocation from '../components/geolocationfencing.js';
import { useLocation, useNavigate } from 'react-router';
import EditLocationPopup from './EditLocationPopup';
import MultiGymSettings from './MultiGymSettings.js';
import MultiGymSettingsModal from './MultiGymSettings.js';
import { useAnalytics } from '../hooks/useAnalytics';
import { useAccess } from '../context/AccessContext';
// import QRScanner from '../QRScanner';
const BusinessInfo = () => {
  const { trackButtonClick } = useAnalytics();
  const [plansInfo, setPlansInfo] = useState(JSON.parse(localStorage.getItem("planInfo")));
  const [info, setInfo] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let popup = params.get('value') == "true" ? true : false;
  const navigate = useNavigate();
  const mdata = location.state?.mdata;

  useEffect(() => {
    if (popup) {
      setBasicModal(true);
      navigate(location.pathname, { replace: true });
    }
  }, [params.get('value')]);
  const [smessage, setSMessage] = useState(null);
  const [apiError, setApiError] = useState(false);
  const [PaymentLink, setPaymentLink] = useState();
  const [Error2, setError2] = useState("")
  const [WaiverForm, setWaiverForm] = useState({
    uniqueNumber: "",
    title: "Digital Waiver Form",
    emergencycontact: 2,
    bloodgroup: 2,
    address: 2,
    phone: 1,
    email: 1,
    pincode: 2,
    consultingcontact: 2,
    governmentidproof: 2,
    checkboxcontent: `By checking this box, I acknowledge that I have read, understood, and agree to the terms and conditions
outlined in the waiver form. I accept full responsibility for my participation, or for the participation of the
minor I am legally responsible for, in climbing activities at Crag Studio, and recognize the inherent risks
involved.`,
    agreement:
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
deserunt mollit anim id est laborum`
    ,
  });

  const logourl = (localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl : logo) : logo)
  const [imageLoaded, setImageLoaded] = useState(true);
  const [geolocation, setGeolocation] = useState({});

  const [gyms, setGyms] = useState([]);
  const [globalPlans, setGlobalPlans] = useState([]);
  const [savedSettings, setSavedSettings] = useState(null);
  const [plans, setPlans] = useState([]);
  const handleReload = () => {
    window.location.reload();
  }


  const [MultiGymSettingsOpen, setMultiGymSettingsOpen] = useState(false);

  // Function to toggle modal open/close
  const multiGymSettingsShow = () => {
    setMultiGymSettingsOpen(prev => !prev);
  };




  const handleMessage = (msg) => {
    setError2(msg);

  };

  useEffect(() => {

    const handleImageLoad = () => {
      setImageLoaded(true);
    };

    const handleImageError = () => {
      setImageLoaded(false);
    };
    const imgElement = document.createElement("img");
    imgElement.onload = handleImageLoad;
    imgElement.onerror = handleImageError;
    imgElement.src = logourl;

    return () => {
      imgElement.onload = null;
      imgElement.onerror = null;
    };
  }, [logourl]);

  function encryptId(id) {
    return btoa(id);
  }
  useEffect(() => {
    if ((PaymentLink && PaymentLink.toggle) && PaymentLink.status == 2) {
      setTimeout(() => {
        checkingConfirmStatus();
      }, 5000);
    }
  }, [PaymentLink]);
  async function checkingConfirmStatus() {
    let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    try {
      let response = await reqConfirmPaymentStatus(gymid);
      if (!response) {
        return;
      }
      if (response === "false") {
        return;
      }
      console.log(response);

      const resObject = await response.json();
      console.log(resObject);
      setPaymentLink(resObject);
      if (resObject && resObject.status && (resObject.status === 1 || resObject.status === 0)) {
        if (resObject.status === 1) {
          setError2("Successfully confirmed payment.");
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  function generateUniqueKey(length) {
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let uniqueKey = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      uniqueKey += characters.charAt(randomIndex);
    }
    return uniqueKey;
  }

  function saveWaiverSettings(data) {
    setWaiverForm(data);
    DigitalWaverShow();
  }

  useEffect(() => {
    if (localStorage.getItem("loggedUserInfo")) {
      fetchData();
      fetchMultiGymsAndPlans()
      fetchGeolocation();
    } else {
      window.location.href = "/login"
    }
    async function fetchGeolocation() {
      const getlocation = await getLocation(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!getlocation) {
        return;
      }

      if (getlocation === "false") {
        return;
      }
      console.log(getlocation);

      const getloc = await getlocation.json();
      console.log(getloc);
      if (!getloc.gymid) {
        let id = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
        const updates = {
          latitude: 17.43496886763314,
          longitude: 78.35971199722289,
          address: "",
          gymid: id,
          radius: 100,
        };
        console.log(updates);
        const saverep = await updateLocation(id, updates);
        console.log(saverep);

        const recinf = await saverep.json();
        setGeolocation(recinf);
      } else {
        setGeolocation(getloc);
      }
    }


    async function fetchData() {
      if (localStorage.getItem("loggedUserInfo")) {
        const waiverRes = await getWaiverSettingsbyGymid(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (waiverRes === "false") {
          setApiError(true)
        } else {
          console.log(waiverRes);

          const waiver = await waiverRes.json();
          console.log(waiver);
          if (!waiver.gymid) {
            const updates = {
              gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
              uniqueNumber: generateUniqueKey(6),
              emergencycontact: 2,
              bloodgroup: 2,
              address: 2,
              phone: 1,
              email: 1,
              title: `Digital Waiver Form`,
              pincode: 2,
              consultingcontact: 2,
              governmentidproof: 2,
              checkboxcontent: `By checking this box, I acknowledge that I have read, understood, and agree to the terms and conditions
  outlined in the waiver form. I accept full responsibility for my participation, or for the participation of the
  minor I am legally responsible for, in climbing activities at Crag Studio, and recognize the inherent risks
  involved.`,
              agreement:
                `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
  dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
  aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
  dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
  deserunt mollit anim id est laborum`
            }
            let saverep = await updateWaiverSettings(updates, JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            console.log(saverep);

            const recinf = await saverep.json();
            console.log(recinf);
            setWaiverForm(recinf);
          } else {
            setWaiverForm(waiver);
          }
        }
        const response = await getGBussinessInfo(
          JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (!response) {
          return;
        }
        if (response === "false") {
          setApiError(true)
        } else {
          console.log(response);

          const recinfo = await response.json();
          console.log(recinfo);
          if (!recinfo) {
            return;
          }

          if (localStorage.getItem("business_save")) {
            setSMessage(localStorage.getItem("business_save"));
            setTimeout(() => {
              setSMessage(null);
              localStorage.removeItem("business_save");
            }, 5000);
          }
          const updatedInfo = { ...recinfo };

          if (!updatedInfo.prefix) {
            updatedInfo.prefix = updatedInfo.businessName ? updatedInfo.businessName.replace(/\s+/g, '').substring(0, 4) : "GYMA";
          }
          if (!updatedInfo.shortcode) {
            updatedInfo.shortcode = "GYMADN";
          }
          if (!updatedInfo.country) {
            updatedInfo.country = "India";
            updatedInfo.state = "Telangana";
          }
          if (updatedInfo.dayid.includes(1) && updatedInfo.sunday.length === 0) {
            updatedInfo.sunday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(2) && updatedInfo.monday.length === 0) {
            updatedInfo.monday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(3) && updatedInfo.tuesday.length === 0) {
            updatedInfo.tuesday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(4) && updatedInfo.wednesday.length === 0) {
            updatedInfo.wednesday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(5) && updatedInfo.thursday.length === 0) {
            updatedInfo.thursday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(6) && updatedInfo.friday.length === 0) {
            updatedInfo.friday = [{ fromTime: "0", toTime: "23" }];
          } if (updatedInfo.dayid.includes(7) && updatedInfo.saturday.length === 0) {
            updatedInfo.saturday = [{ fromTime: "0", toTime: "23" }];
          }
          setInfo(updatedInfo);
          console.log(updatedInfo);
        }
      }
    }
  }, []);





  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
        if (!loggedUser?.gymid) return;

        const response = await getGlobalPlanAccess({ homeGymId: loggedUser?.gymid });

        if (!response) {
          return;
        }
        if (response === "false") {
          return;
        }
        console.log(response, 'response');

        const data = await response.json();

        setPlans(data?.allowedPlanNames || []);
      } catch (error) {
        console.error("Error fetching global plans:", error);
      }
    };

    fetchPlans();
  }, []);



  async function fetchPaymentLink() {
    const paymentLinkSetting = await getPaymentLinkSetting(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
    if (!paymentLinkSetting) {
      return;
    }
    if (paymentLinkSetting == "false") {
      return;
    }
    console.log(paymentLinkSetting);

    const paymentLinkSettings = await paymentLinkSetting.json();
    if (paymentLinkSettings?.gymid) {
      console.log(paymentLinkSettings);
      setPaymentLink(paymentLinkSettings);
      if (paymentLinkSettings.status == 2) {
        checkingConfirmStatus();
      }
    }
  }
  useEffect(() => {
    fetchPaymentLink();

  }, []);



  const fetchMultiGymsAndPlans = async () => {
    try {
      const res = await getMultiGymsAndPlans(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!res) {
        return;
      }
      if (res === "false") {
        return;
      }
      console.log(res);

      const data = await res.json()
      if (data?.gyms || data?.globalPlans || data?.savedSettings) {
        setGyms(data?.gyms);
        setGlobalPlans(data?.globalPlans);
        setSavedSettings(data?.savedSettings);
      }

    } catch (error) {
      console.error("Error fetching gyms and plans:", error);
    }
  };


  const [basicModal, setBasicModal] = useState(false);
  const toggleShow = () => setBasicModal(!basicModal);
  const [paymentMethods, setPaymentMethods] = useState(false);
  const paymentMethodsShow = () => setPaymentMethods(!paymentMethods);
  const [taxSettings, setTaxSettings] = useState(false);
  const taxSettingsShow = () => setTaxSettings(!taxSettings);
  const [eaEnabled, setEaEnabled]                         = useState(false);
  const [eaUniqueKey, setEaUniqueKey]                     = useState("");
  const [eaToggling, setEaToggling]                       = useState(false);
  const [eaKeyCopied, setEaKeyCopied]                     = useState(false);
  const [eaRegenConfirm, setEaRegenConfirm]               = useState(false);
  const [eaRegenerating, setEaRegenerating]               = useState(false);
  const [eaAllowMultiple, setEaAllowMultiple]             = useState(false);
  const [eaAllowMultipleSaving, setEaAllowMultipleSaving] = useState(false);
  const [eaTimezoneMode, setEaTimezoneMode]               = useState("business");
  const [eaCustomTimezone, setEaCustomTimezone]           = useState(null);
  const [eaTimezoneSaving, setEaTimezoneSaving]           = useState(false);

  useEffect(() => {
    async function fetchEADevice() {
      const gymid = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null;
      if (!gymid) return;
      try {
        const res = await getEADeviceSettings(gymid);
        console.log("Fetched EA Device settings:", res);
        if (res && res.ok) {
          const data = await res.json();
          console.log("Fetched EA Device settings:", data);
          if (data.device) {
            setEaEnabled(!!data.device.enabled);
            setEaUniqueKey(data.device.uniqueKey || "");
            setEaAllowMultiple(!!data.device.allowMultipleCheckins);
            setEaTimezoneMode(data.device.timezoneMode || "business");
            setEaCustomTimezone(data.device.customTimezone || null);
          }
        }
      } catch (e) {
        console.log("Error fetching EA Device settings:", e);
      }
    }
    fetchEADevice();
  }, []);

  const handleEAToggle = async () => {
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    const next = !eaEnabled;
    console.log("Toggle EA Device. Current state:", next);
    setEaToggling(true);
    try {
      const res = await toggleEADevice(gymid, next);
      console.log("Toggle EA Device response:", res);

      if (res && res.ok) {
        console.log("EA Device toggled successfully. Fetching updated settings...");
        const data = await res.json();
        setEaEnabled(data.enabled);
        console.log("Updated EA Device settings:", data);
        if (data.uniqueKey) setEaUniqueKey(data.uniqueKey);
      }
      console.log("Finished handling EA Device toggle.");
    } catch (e) {
      console.log("Error toggling EA Device:", e);
    }
    setEaToggling(false);
  };

  const handleEARegenerate = async () => {
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    setEaRegenerating(true);
    setEaRegenConfirm(false);
    try {
      const res = await regenerateEAKey(gymid);
      if (res && res.ok) {
        const data = await res.json();
        if (data.uniqueKey) setEaUniqueKey(data.uniqueKey);
      }
    } catch (e) { /* silent */ }
    setEaRegenerating(false);
  };

  const handleEaTimezoneModeChange = async (mode) => {
    if (mode === eaTimezoneMode) return;
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    setEaTimezoneMode(mode);
    setEaTimezoneSaving(true);
    try {
      const res = await updateEADeviceSettings(gymid, { timezoneMode: mode });
      if (res && res.ok) {
        const data = await res.json();
        setEaTimezoneMode(data.timezoneMode || "business");
      }
    } catch (e) {
      console.log("Error updating timezoneMode:", e);
    }
    setEaTimezoneSaving(false);
  };

  const handleEaCustomTimezoneChange = async (timezone) => {
    setEaCustomTimezone(timezone);
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    setEaTimezoneSaving(true);
    try {
      const res = await updateEADeviceSettings(gymid, { customTimezone: timezone });
      if (res && res.ok) {
        const data = await res.json();
        setEaCustomTimezone(data.customTimezone || null);
      }
    } catch (e) {
      console.log("Error updating customTimezone:", e);
    }
    setEaTimezoneSaving(false);
  };

  const PL_DEVICE_KEY = 'pinelabsActiveDevice';
  const [plActiveDevice, setPlActiveDevice] = useState(() => {
    try { return JSON.parse(localStorage.getItem(PL_DEVICE_KEY)) || null; } catch { return null; }
  });

  const handleSelectPinelabsDevice = (device) => {
    setPlActiveDevice(device);
    localStorage.setItem(PL_DEVICE_KEY, JSON.stringify(device));
  };

  const emptyDevice = () => ({ deviceName: '', merchantId: '', securityToken: '', clientId: '', storeId: '', deviceNumber: '' });

  const [pinelabsDevices, setPinelabsDevices] = useState([]);
  const [pinelabsModal, setPinelabsModal]     = useState(false);
  const [pinelabsForm, setPinelabsForm]       = useState([]);
  const [pinelabsSaving, setPinelabsSaving]   = useState(false);

  const pinelabsModalShow = () => {
    setPinelabsModal(prev => !prev);
  };

  useEffect(() => {
    async function fetchPinelabsSettings() {
      const gymid = localStorage.getItem("loggedUserInfo")
        ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : null;
      if (!gymid) return;
      try {
        const res = await getPinelabsSettings(gymid);
        if (res && res.ok) {
          const data = await res.json();
          setPinelabsDevices(data);
        }
      } catch (e) { /* silent */ }
    }
    fetchPinelabsSettings();
  }, []);

  const handlePinelabsEdit = () => {
    setPinelabsForm(pinelabsDevices.map(d => ({ ...d })));
    pinelabsModalShow();
  };

  const updatePinelabsDevice = (i, field, val) => {
    setPinelabsForm(prev => prev.map((d, idx) => idx !== i ? d : { ...d, [field]: val }));
  };

  const handlePinelabsSave = async () => {
    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    setPinelabsSaving(true);
    try {
      const res = await savePinelabsSettings({ devices: pinelabsForm }, gymid);
      if (res && res.ok) {
        const data = await res.json();
        setPinelabsDevices(data);
        pinelabsModalShow();
        setError2("Pine Labs settings saved successfully.");
      }
    } catch (e) { /* silent */ }
    setPinelabsSaving(false);
  };

  const [locationSetting, setLocationSetting] = useState(false);
  const locationFenchingShow = () => setLocationSetting(!locationSetting);

  const [bussinessHours, setBussinessHours] = useState(false);
  const bussinessHoursShow = () => setBussinessHours(!bussinessHours);

  const [DigitalWaver, setDigitalWaver] = useState(false);
  const DigitalWaverShow = () => setDigitalWaver(!DigitalWaver);

  const [QRDigitalWaver, setQRDigitalWaver] = useState(false);
  const QRDigitalWaverShow = () => setQRDigitalWaver(!QRDigitalWaver);

  const [QRDigitalWaverconfirmation, setQRDigitalWaverconfirmation] = useState(false);
  const QRDigitalWaverconfirmationShow = () => setQRDigitalWaverconfirmation(!QRDigitalWaverconfirmation);
  const [copyLink, setcopyLink] = useState(false);

  let uniqueId = WaiverForm.uniqueNumber;
  const encryptedId = encryptId(uniqueId);
  const pathAndQuery = `/waiver?id=${encryptedId}`;
  const baseUrl = window.location.origin;
  const fullUrl = baseUrl + pathAndQuery;
  const link = fullUrl;


  function onbacktoStaff(flag) {
    setError2(flag);

    setTimeout(() => {
      window.location.reload();
    }, 1000);

  }


  const reGenerateLink = async () => {
    const updates = {
      gymid: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
      uniqueNumber: generateUniqueKey(6),
    };
    let saverep = await updateWaiverSettings(updates, localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "");
    if (saverep === "false") {
      setApiError(true)
    } else {
      console.log(saverep);

      const recinfo = await saverep.json();
      console.log(recinfo);
      setWaiverForm(recinfo);
    }
    QRDigitalWaverconfirmationShow();
  };
  const handleCopyLink = () => {
    copy(link);
    setcopyLink(true);
  };
  // const handlePreview = () => {
  //   window.open(link, '_self');
  // };
  const modalBodyRef = useRef(null);
  // <link rel="icon" href="../../build/favicon.ico" />
  // <link rel="icon" href=${faviconUrl}/>
  const handlePrintPDF = () => {
    const contentToPrint = `
    <html>
      <head>
      <title>Gym Management</title>
  <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
  <link rel="icon" href="/favicon.ico" />
          </head>
      <body style="background-color:#d7e1ee;">
        <center>
        <div style="
        min-width: 50%;
        background-color: #fff;
        padding: 0px 0px 160px 0px;
        border-radius: 7px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.075);
        ">
        <div className='d-flex align-items-center Waiver-logo'>
        <div style="display: flex;align-items: center;justify-content: center;">
          <img src=${imageLoaded ? logourl : logo} style="width:140px" />
          <div style="display: flex;align-items: flex-start;flex-direction: column;margin-top: 0.5rem;border-left: 2px solid #e0e0e0;padding-left: 0.5rem;">
            <h4 style="color: #193b8b; margin:0px; !important; font-family: &quot;Inter&quot;, sans-serif;">${info && info.businessName ? info.businessName : "GYM Admin Online"}</h4>
            <div className='d-flex'>
              <p style="margin:0px; !important;margin-top: 10px; font-family: &quot;Inter&quot;, sans-serif;">
              ${(info.address || info.city) ? ((info.address ? info.address : '') +
        ((info.address && info.city) ? ', ' : '') +
        (info.city ? (info.city) : '')
      ) : "Suadaraiah Vignana Kendram, Gachibowli, Hyderabad"}
              </p>
              </div>
              </div>
              </div>
              </div>
              <div style="border-bottom: 2px solid #ddd;margin: 15px 0px;width: 90%;"></div>
              <div>
              <h1 style="padding-top: 20px;font-family: &quot;Inter&quot;, sans-serif;">${(WaiverForm && WaiverForm.title) ? WaiverForm.title : "Digital Waiver Form"}</h1><br/>
              <div>
              ${ReactDOMServer.renderToString(<QRCodeSVG style={{ width: '300px', height: '300px' }} value={link} />)}
              </div>
              </div>
              </div>
        </center>
      </body>
    </html>
  `;


    // Create a hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);


    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(contentToPrint);
    iframeDoc.close();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 200);
  };

  const truncateContent = (content, maxLength) => {
    if (content && (content.length > maxLength)) {
      return content.substring(0, maxLength) + '...';
    } else {
      return content;
    }
  };
  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };
  let col = 4;
  if ((plansInfo !== null && !plansInfo?.feature?.digitalwaiver)) {
    col = 6;
  }

  const { loading, handlePageAccess } = useAccess();
  const roleAccess = handlePageAccess("businessinfo")
  const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));

  return (
    <>
      <LeftPane isactive="2" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> : <div
        className="gym-main rightContent"
      >

        {/* <QRScanner /> */}
        <div className="gym-container" id="showcase">
          {smessage && (
            <div>
              <Toast message={smessage} />
            </div>
          )}
        </div>

        <div>
          <div className="business_Info_page" id="contact">
            <MDBRow>
              <MDBCol sm="12" md={col} lg={col}>

                {roleAccess?.businessdetails !== 0 && <MDBCard>
                  <MDBCardBody>
                    <MDBCardTitle>
                      <label>Business Details </label>
                      {roleAccess?.businessdetails !== 2 && <div>
                        <MDBIcon fas icon="edit" onClick={() => toggleShow()} />
                      </div>}
                    </MDBCardTitle>
                    <MDBCardText>
                      <MDBRow>

                        <MDBCol>
                          <div className="payment-span chip">
                            <label>Business Name:</label> <label className="fw-600 lower" >{info.businessName}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Owner First Name:</label> <label className="fw-600 lower">{info.firstName}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Owner Last Name:</label> <label className="fw-600 lower">{info.lastName}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Email:</label> <label className="fw-600 lower">{info.businessEmail}</label>
                            {info.isemailverified && <MDBIcon fas icon="check-circle text-success ms-1" />}
                          </div>

                          <div className="payment-span chip">
                            <label>Contact No:</label> <label className="fw-600 lower">{info.contactNumber}</label>
                            {info.isnumberverified && <MDBIcon fas icon="check-circle text-success ms-1" />}
                          </div>

                          <div className="payment-span chip">
                            <label>City:</label> <label className="fw-600 lower">{info.city}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>State:</label> <label className="fw-600 lower">{info.state}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Country:</label> <label className="fw-600 lower">{info.country}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>Timezone:</label> <label className="fw-600 lower">{info.timezone && info.timezone.value}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Transaction Id Prefix:</label> <label className="fw-600 lower">{info.prefix}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>SMS ShortCode:</label> <label className="fw-600 lower">{info.shortcode}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>Preferred Date Format:</label> <label className="fw-600 lower">{info.dateFormat ? info.dateFormat : "YYYY/MM/DD"}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>Member Capacity:</label> <label className="fw-600 lower">{info.memberCapacity}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Business Address:</label> <label className="fw-600 lower">{info.address}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>GST Number:</label> <label className="fw-600 lower">{info.gstnumber && info.gstnumber !== "" ? info.gstnumber : "--"}</label>
                          </div>
                          <div className="payment-span chip">
                            <label>Display Name:</label> <label className="fw-600 lower">{info.displayname && info.displayname !== "" ? info.displayname : "--"}</label>
                          </div>

                          <div className="payment-span chip">
                            <label>Member Check-In Duration:</label> <label className="fw-600 lower" >{info.checkoutduration ? info.checkoutduration : 1.5} hours</label>
                          </div>

                          <div className="mt-3">
                            <label className="m-0 fw-600">Business Logo:</label>
                            <div className="py-2">
                              <img src={imageLoaded ? logourl : logo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '80px' }} />
                            </div>
                          </div>
                        </MDBCol>

                      </MDBRow>

                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>}

                {roleAccess?.businesshours !== 0 && <MDBCard className=" mt-22px mb-5">
                  <MDBCardBody>
                    <MDBCardTitle>
                      <label>Business Hours </label>
                      {roleAccess?.businesshours !== 2 && <div onClick={bussinessHoursShow}>
                        <MDBIcon fas icon="edit" />
                      </div>}
                    </MDBCardTitle>
                    <MDBCardText>
                      {info.dayid && info.dayid.length > 0 &&
                        <div className="d-block">
                          {info.dayid.includes(1) &&
                            <div className="payment-span chip">
                              <label className='d-inline'>Sunday:
                                <span className="m-1">
                                  {info.sunday && info.sunday.length > 0 && info.sunday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12)) + " PM") : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12)) + " PM") : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime))) + " AM"}{((info.sunday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}
                                </span></label>
                            </div>}

                          {info.dayid.includes(2) &&
                            <div className="payment-span chip">
                              <label>Monday:
                                <span className="m-1">
                                  {info.monday && info.monday.length > 0 && info.monday.map((obj, index) =>
                                    <label className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.monday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}

                                </span></label>
                            </div>}

                          {info.dayid.includes(3) &&
                            <div className="payment-span chip">
                              <label>Tuesday:
                                <span className="m-1">
                                  {info.tuesday && info.tuesday.length > 0 && info.tuesday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM ")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.tuesday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}
                                </span>
                              </label>
                            </div>}
                          {info.dayid.includes(4) &&
                            <div className="payment-span chip">
                              <label>Wednesday:
                                <span className="m-1">
                                  {info.wednesday && info.wednesday.length > 0 && info.wednesday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM ")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.wednesday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}

                                </span></label>
                            </div>}
                          {info.dayid.includes(5) &&
                            <div className="payment-span chip">
                              <label>Thursday:
                                <span className="m-1">
                                  {info.thursday && info.thursday.length > 0 && info.thursday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM ")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.tuesday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}

                                </span></label>
                            </div>}
                          {info.dayid.includes(6) &&
                            <div className="payment-span chip">
                              <label>Friday:
                                <span className="m-1">
                                  {info.friday && info.friday.length > 0 && info.friday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.friday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}

                                </span></label>
                            </div>}
                          {info.dayid.includes(7) &&
                            <div className="payment-span chip">
                              <label>Saturday:
                                <span className="m-1">
                                  {info.saturday && info.saturday.length > 0 && info.saturday.map((obj, index) =>
                                    <label key={index} className="fw-600"> From {parseFloat(obj.fromTime) > 11 ? ((parseFloat(obj.fromTime) - (parseFloat(obj.fromTime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.fromTime) === 0 ? 12 : parseFloat(obj.fromTime)) + " AM")}
                                      To {parseFloat(obj.toTime) > 11 ? ((parseFloat(obj.toTime) - (parseFloat(obj.toime) === 12 ? 0 : 12) + " PM")) : ((parseFloat(obj.toTime) === 0 ? 12 : parseFloat(obj.toTime)) + " AM")}{((info.saturday.length - 1) === index ? <>&nbsp;</> : ",")} </label>
                                  )}

                                </span></label>
                            </div>}
                        </div>}
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>}

                {/* ── ESSL Biometric card ── */}
{/* ── ESSL Biometric card ── */}
<MDBCard className="mt-22px mb-4">
  <MDBCardBody>
    <MDBCardTitle>
      <label>ESSL Biometric</label>
    </MDBCardTitle>
    <MDBCardText>

      {/* Row: Enable biometric */}
      <div className="d-flex align-items-center justify-content-between py-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
        <div>
          <div className="fw-600" style={{ fontSize: 14 }}>Enable Biometric</div>
          <div className="text-muted" style={{ fontSize: 12 }}>Sync attendance from ESSL device</div>
        </div>
        <div className="form-check form-switch m-0">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="eaEnableSwitch"
            checked={eaEnabled}
            onChange={handleEAToggle}
            disabled={eaToggling}
            style={{ 
              cursor: 'pointer',
              width: '48px',
              height: '24px',
              marginTop: '0'
            }}
          />
        </div>
      </div>

      {/* Row: Multiple check-ins (only when enabled) */}
      {eaEnabled && (
        <div className="d-flex align-items-center justify-content-between py-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <div className="fw-600" style={{ fontSize: 14 }}>Multiple Check-ins Per Day</div>
            <div className="text-muted" style={{ fontSize: 12 }}>Allow same member to check in more than once daily</div>
          </div>
          <div className="d-flex align-items-center gap-2">
            {eaAllowMultipleSaving && (
              <span className="text-muted" style={{ fontSize: 12 }}>
                <MDBIcon fas icon="spinner" spin className="me-1" />
                Saving…
              </span>
            )}
            <div className="form-check form-switch m-0">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="eaAllowMultipleSwitch"
                checked={eaAllowMultiple}
                disabled={eaAllowMultipleSaving}
                style={{ 
                  cursor: 'pointer',
                  width: '48px',
                  height: '24px',
                  marginTop: '0'
                }}
                onChange={async () => {
                  const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
                  const next = !eaAllowMultiple;
                  setEaAllowMultipleSaving(true);
                  try {
                    const res = await updateEADeviceSettings(gymid, { allowMultipleCheckins: next });
                    if (res && res.ok) {
                      const data = await res.json();
                      setEaAllowMultiple(!!data.allowMultipleCheckins);
                    }
                  } catch (e) {
                    console.log("Error updating allowMultipleCheckins:", e);
                  }
                  setEaAllowMultipleSaving(false);
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Row: Time Zone Configuration (only when enabled) */}
      {eaEnabled && (
        <div className="py-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <div className="fw-600" style={{ fontSize: 14 }}>Time Zone Configuration</div>
              <div className="text-muted" style={{ fontSize: 12 }}>How to interpret the check-in time reported by the device</div>
            </div>
            {eaTimezoneSaving && (
              <span className="text-muted" style={{ fontSize: 12 }}>
                <MDBIcon fas icon="spinner" spin className="me-1" />
                Saving…
              </span>
            )}
          </div>
          <div className="d-flex flex-column gap-2 mt-2">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="eaTimezoneMode"
                id="eaTimezoneModeBusiness"
                checked={eaTimezoneMode === "business"}
                disabled={eaTimezoneSaving}
                onChange={() => handleEaTimezoneModeChange("business")}
              />
              <label className="form-check-label" htmlFor="eaTimezoneModeBusiness" style={{ fontSize: 13 }}>
                Use Business Time Zone{info.timezone && info.timezone.value ? ` (${info.timezone.value})` : ""}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="eaTimezoneMode"
                id="eaTimezoneModeCustom"
                checked={eaTimezoneMode === "custom"}
                disabled={eaTimezoneSaving}
                onChange={() => handleEaTimezoneModeChange("custom")}
              />
              <label className="form-check-label" htmlFor="eaTimezoneModeCustom" style={{ fontSize: 13 }}>
                Custom Time Zone
              </label>
            </div>
            {eaTimezoneMode === "custom" && (
              <div className="mt-1" style={{ maxWidth: 360 }}>
                <TimezoneSelect
                  className="label-offset"
                  value={eaCustomTimezone || ""}
                  onChange={handleEaCustomTimezoneChange}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {/* Device Key (only when enabled) */}
      {eaEnabled && eaUniqueKey && (
        <div className="mt-3">
          <label className="fw-600 mb-1" style={{ fontSize: 13 }}>Device Key</label>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <span className="payment-span chip fw-600" style={{ letterSpacing: '0.1em' }}>
              {eaRegenerating ? "Generating..." : eaUniqueKey}
            </span>
            <MDBBtn size="sm" color={eaKeyCopied ? "success" : "secondary"} disabled={eaRegenerating}
              onClick={() => { copy(eaUniqueKey); setEaKeyCopied(true); setTimeout(() => setEaKeyCopied(false), 2000); }}
            >
              <MDBIcon fas icon={eaKeyCopied ? "check" : "copy"} className="me-1" />
              {eaKeyCopied ? "Copied" : "Copy"}
            </MDBBtn>
            <MDBBtn size="sm" color="danger" outline disabled={eaRegenerating} onClick={() => setEaRegenConfirm(true)}>
              <MDBIcon fas icon="sync-alt" className="me-1" />
              Regenerate
            </MDBBtn>
          </div>
          <p className="text-muted mt-2 mb-0" style={{ fontSize: 12 }}>
            Paste this key into your EA server config as <code>Device Key</code>.
          </p>
        </div>
      )}

    </MDBCardText>
  </MDBCardBody>
</MDBCard>


              </MDBCol>

              <MDBCol sm="12" md={col} lg={col}>


                {roleAccess?.paymentmethods !== 0 && <MDBCard className='mobile'>
                  <MDBCardBody>
                    <MDBCardTitle>
                      <label>Payment Methods</label>
                      {roleAccess?.paymentmethods !== 2 && <div onClick={paymentMethodsShow}>
                        <MDBIcon fas icon="edit" />
                      </div>}
                    </MDBCardTitle>
                    <MDBCardText>
                      <div className="payments mt-3">

                        <span className="payment-span chip">Cash </span>

                        <span className="payment-span chip">Debit/Credit Card</span>

                        <span className="payment-span chip">UPI</span>

                        <span className="payment-span chip">
                          Wallets ( Gpay,PhonePe, Paytm, etc)
                        </span>

                        <span className="payment-span chip">Coupons</span>

                        {info.userpaymethods &&
                          info.userpaymethods.map((item, index) => (
                            <>

                              <span className="payment-span chip">
                                <label>{item.title}</label>:{" "}{item.label}
                              </span>

                            </>
                          ))}
                        {PaymentLink && PaymentLink.toggle &&
                          <div className='mt-2'>
                            <label class="m-0 fw-600">PhonePe Payment Link:</label>
                            <div>
                              <span className="payment-span chip">
                                <label>Merchant ID</label>: {PaymentLink.merchantid}
                              </span>
                              <span className="payment-span chip">
                                <label>Salt Key</label>: {PaymentLink.merchantkey}
                              </span>
                              <span className="payment-span chip">
                                <label>Salt Index</label>: {PaymentLink.merchantindex}
                              </span>
                            </div>
                            {PaymentLink.status == 1 ?
                              <label
                                className="clr-green"
                              >
                                <MDBIcon fas icon="check" /> Confirmed
                              </label>
                              : ""}
                            {PaymentLink.status == 2 ? <label className="clr-orange">
                              <MDBIcon far icon="clock" /> Waiting For Confirm
                            </label> : ""}
                            {PaymentLink.status == 0 ? <label className="clr-red">
                              <MDBIcon fas icon="times" /> Failed to confirm
                            </label> : ""}
                          </div>}

                        {/* <div className='mt-2'>
                          <label class="m-0 fw-600">Razorpay Payment Link:</label>
                          <div className='py-2'>
                            <MDBIcon fas icon="check" color='success' className='me-2' />
                            Easymember Razorpay Gateway
                          </div>

                          <div>
                            <div className='py-2'>
                              <MDBIcon fas icon="check" color='success' className='me-2' />
                              Your Razorpay Gateway
                            </div>

                            <div className='d-flex flex-wrap'>
                              <MDBChip>
                                <label>Merchant ID</label>: M2215WRVYPM71
                              </MDBChip>

                              <MDBChip>
                                <label>Merchant Key</label>: 12
                              </MDBChip>
                            </div>

                          </div>

                          
                            <label
                              className="clr-green"
                            >
                              <MDBIcon fas icon="check" /> Confirmed
                            </label>
                          
                        <label className="clr-orange">
                            <MDBIcon far icon="clock" /> Waiting For Confirm
                          </label> 
                           <label className="clr-red">
                            <MDBIcon fas icon="times" /> Failed to confirm
                          </label> 

                        </div> */}

                      </div>

                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>}

                {roleAccess?.taxsettings !== 0 && <MDBCard className="mt-22px ">
                  <MDBCardBody>
                    <MDBCardTitle>
                      <label>Tax Settings</label>
                      {roleAccess?.taxsettings !== 2 && <div onClick={taxSettingsShow}>
                        <MDBIcon fas icon="edit" />
                      </div>}
                    </MDBCardTitle>
                    <MDBCardText>
                      <div className="payments  mt-3">
                        {info?.hsn?.check && <span className="payment-span chip">HSN Code: <span className="fw-600">{info?.hsn?.value}</span></span>

                        }
                        {info.ddgst &&

                          <span className="payment-span chip">GST: <span className="fw-600">18%</span></span>

                        }
                        {info.ddgst == null &&

                          <span className="payment-span chip">GST: <span className="fw-600">18%</span></span>

                        }
                        {info.ugsttax &&
                          info.ugsttax.map((item, index) => (
                            <>


                              <span className="payment-span chip">{item.title}: <span className="fw-600">{item.label}{"%"}</span></span>

                            </>
                          ))}

                      </div>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>}

                {roleAccess?.geolocation !== 0 && <MDBCard className="mt-3 h-auto mb-4" >
                  <MDBCardBody className=''>
                    <EditLocationPopup onStatusChange={handleMessage} access={roleAccess?.geolocation} />
                  </MDBCardBody>
                </MDBCard>}

                {/* ── Pine Labs POS card ── */}
                <MDBCard className="mt-3 mb-4">
                  <MDBCardBody>
                    <MDBCardTitle>
                      <label>Pine Labs POS</label>
                      <div onClick={handlePinelabsEdit} style={{ cursor: 'pointer' }}>
                        <MDBIcon fas icon="edit" />
                      </div>
                    </MDBCardTitle>
                    <MDBCardText>
                      {pinelabsDevices.length === 0 ? (
                        <div className="text-muted mt-2" style={{ fontSize: 13 }}>
                          No devices configured. Click <MDBIcon fas icon="edit" className="mx-1" /> to add.
                        </div>
                      ) : (
                        <>
                          <div className="text-muted mb-2 mt-1" style={{ fontSize: 12 }}>
                            Select the device connected to this terminal:
                          </div>
                          <div className="payments">
                            {pinelabsDevices.map((d, i) => {
                              const isActive = plActiveDevice && (
                                plActiveDevice._id === d._id ||
                                (plActiveDevice.deviceNumber && plActiveDevice.deviceNumber === d.deviceNumber)
                              );
                              return (
                                <div
                                  key={d._id || i}
                                  onClick={() => handleSelectPinelabsDevice(d)}
                                  className="payment-span chip d-flex align-items-center justify-content-between mb-1"
                                  style={{
                                    cursor: 'pointer',
                                    border: isActive ? '1.5px solid #0d6efd' : '',
                                    background: isActive ? '#eef3ff' : '',
                                    width: '100%',
                                  }}
                                >
                                  <div>
                                    <span className="fw-600">{d.deviceName || `Device ${i + 1}`}</span>
                                    {d.storeId && <span className="text-muted ms-2" style={{ fontSize: 11 }}>Store: {d.storeId}</span>}
                                    {d.deviceNumber && <span className="text-muted ms-1" style={{ fontSize: 11 }}>#{d.deviceNumber}</span>}
                                  </div>
                                  {isActive
                                    ? <span className="badge bg-primary ms-2" style={{ fontSize: 10 }}>
                                        <MDBIcon fas icon="check" className="me-1" />This System
                                      </span>
                                    : <span className="badge bg-light text-secondary border ms-2" style={{ fontSize: 10 }}>Select</span>
                                  }
                                </div>
                              );
                            })}
                          </div>
                          {plActiveDevice && (
                            <div className="text-muted mt-2" style={{ fontSize: 11 }}>
                              <MDBIcon fas icon="info-circle" className="me-1" />
                              Active device is stored in this browser only.
                            </div>
                          )}
                        </>
                      )}
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>

              </MDBCol>

              {(plansInfo !== null && plansInfo?.feature?.digitalwaiver) && roleAccess?.digitalwaiver !== 0 ? <>
                <MDBCol sm="12" md="4" lg="4">
                  <MDBCard className="mb-4">
                    <MDBCardBody>
                      <MDBCardTitle>
                        <label> Digital Waiver </label>
                        {roleAccess?.digitalwaiver !== 2 && <div onClick={() => DigitalWaverShow()}>
                          <MDBIcon fas icon="edit" />
                        </div>}
                      </MDBCardTitle>
                      <MDBCardText>
                        <div className="mt-3">
                          <p className='mt-2 mb-1 fw-bold'>Title</p>
                          <label className="mt-0">{WaiverForm.title}</label>
                        </div>

                        {/* Display multiple checkboxes */}
                        <div className="mt-3">
                          <h6 className='mt-2 fw-bold'>Checkboxes</h6>
                          {WaiverForm.checkboxes && WaiverForm.checkboxes.length > 0 ? (
                            WaiverForm.checkboxes.map((checkbox, index) => (
                              <div key={checkbox.id || index} className="mb-1">
                                <div className="d-flex align-items-start">
                                  <input type="checkbox" className="me-2 mt-1" disabled />
                                  <div className="flex-grow-1">
                                    <div className="ps-0">
                                      {truncateContent(checkbox.text, 200)}
                                    </div>
                                    <div className={` mb-1 ${checkbox.required ? 'text-warning' : 'text-primary'}`} style={{ fontSize: '12px' }}>
                                      {checkbox.required ? '(Required)' : '(Optional)'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            // Fallback for old data format
                            <div>
                              <div className="d-flex align-items-start">
                                <input type="checkbox" className="me-2 mt-1" disabled />
                                <div className="flex-grow-1">
                                  <div className="ps-0">
                                    {truncateContent(WaiverForm.checkboxcontent, 200)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          <h6 className='mt-3 fw-bold'>Agreement text</h6>
                          <div className="ps-0" title={stripHtmlTags(WaiverForm.agreement)}
                            dangerouslySetInnerHTML={{ __html: truncateContent(WaiverForm.agreement, 300) }} />

                          <h6 className='mt-3'>Optional fields</h6>
                          <div className='d-flex flex-wrap'>
                            <MDBChip>
                              <span className='me-1'>Email: </span>
                              <span className='fw-600 '>
                                {WaiverForm.email === 1 ? 'Mandatory' :
                                  WaiverForm.email === 2 ? 'Optional' :
                                    WaiverForm.email === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Phone: </span>
                              <span className='fw-600 '>
                                {WaiverForm.phone === 1 ? 'Mandatory' :
                                  WaiverForm.phone === 2 ? 'Optional' :
                                    WaiverForm.phone === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Blood group: </span>
                              <span className='fw-600 '>
                                {WaiverForm.bloodgroup === 1 ? 'Mandatory' :
                                  WaiverForm.bloodgroup === 2 ? 'Optional' :
                                    WaiverForm.bloodgroup === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Address: </span>
                              <span className='fw-600 '>
                                {WaiverForm.address === 1 ? 'Mandatory' :
                                  WaiverForm.address === 2 ? 'Optional' :
                                    WaiverForm.address === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Pincode: </span>
                              <span className='fw-600 '>
                                {WaiverForm.pincode === 1 ? 'Mandatory' :
                                  WaiverForm.pincode === 2 ? 'Optional' :
                                    WaiverForm.pincode === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>GovernmentId Proof: </span>
                              <span className='fw-600 '>
                                {WaiverForm.governmentidproof === 1 ? 'Mandatory' :
                                  WaiverForm.governmentidproof === 2 ? 'Optional' :
                                    WaiverForm.governmentidproof === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Guardian contact: </span>
                              <span className='fw-600 '>
                                {WaiverForm.consultingcontact === 1 ? 'Mandatory' :
                                  WaiverForm.consultingcontact === 2 ? 'Optional' :
                                    WaiverForm.consultingcontact === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                            <MDBChip>
                              <span className='me-1'>Emergency contact: </span>
                              <span className='fw-600 '>
                                {WaiverForm.emergencycontact === 1 ? 'Mandatory' :
                                  WaiverForm.emergencycontact === 2 ? 'Optional' :
                                    WaiverForm.emergencycontact === 3 ? 'Exclude' : ''}
                              </span>
                            </MDBChip>
                          </div>
                          <div className="routing-border">
                          </div>

                          <div className="d-flex align-items-center justify-content-center">
                            <MDBBtn className="ms-2" onClick={QRDigitalWaverShow}><MDBIcon fas icon="qrcode" /> Show QR Code</MDBBtn>

                          </div>
                        </div>
                      </MDBCardText>
                    </MDBCardBody>
                  </MDBCard>



                  {mdata && mdata.length > 1 && (loggedUser.rolevalues && loggedUser.rolevalues.includes(1)) && (
                    <MDBCard className="mt-22px">
                      <MDBCardBody>
                        <MDBCardTitle className="d-flex justify-between items-center">
                          <label>Partner Gym Settings</label>
                          <div onClick={multiGymSettingsShow}>
                            <MDBIcon fas icon="edit" />
                          </div>
                        </MDBCardTitle>

                        <MDBCardText>
                          <MultiGymSettingsModal
                            open={MultiGymSettingsOpen}
                            setOpen={setMultiGymSettingsOpen}
                            gyms={gyms}
                            globalPlans={globalPlans}
                            savedSettings={savedSettings}
                          />
                        </MDBCardText>

                        <MDBRow>

                          <MDBCol>
                            <MDBRow className="flex-wrap g-2">
                              {plans && plans.length > 0 && plans.map((planName, index) => (
                                <MDBCol key={index} size="auto">
                                  <div className="payment-span chip">
                                    <label className="fw-600 lower">{planName}</label>
                                  </div>
                                </MDBCol>
                              ))}
                            </MDBRow>
                          </MDBCol>
                        </MDBRow>
                      </MDBCardBody>
                    </MDBCard>
                  )}



                </MDBCol>
              </> : ""}
            </MDBRow>
          </div >
        </div >
      </div >}

      <MDBModal open={basicModal} setOpen={setBasicModal} show={basicModal} setShow={setBasicModal} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Business Details</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>

              <BusinessPage toggleShow={toggleShow} Gid={info._id} from={"member"} onbacktoStaff={onbacktoStaff} />

            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>


      <MDBModal show={paymentMethods} setShow={setPaymentMethods} open={paymentMethods} setOpen={setPaymentMethods} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Payment Methods</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={paymentMethodsShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {paymentMethods && <PaymentMethods toggleShow={setPaymentMethods} paymentMethods={paymentMethods} />}

            </MDBModalBody>

            <MDBModalFooter className="d-none">
              <MDBBtn color='secondary' onClick={paymentMethodsShow}>
                Close
              </MDBBtn>
              <MDBBtn>Save</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal show={taxSettings} setShow={setTaxSettings} open={taxSettings} setOpen={setTaxSettings} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Tax Settings</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={taxSettingsShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>

              <TaxSettings toggleShow={setTaxSettings} />

            </MDBModalBody>
            <MDBModalFooter className="d-none">
              <MDBBtn color='secondary' onClick={taxSettingsShow}>
                Close
              </MDBBtn>
              <MDBBtn >Save</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal show={bussinessHours} setShow={setBussinessHours} open={bussinessHours} setOpen={setBussinessHours} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Business Hours</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={bussinessHoursShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>

              <BussinessHours toggleShow={setBussinessHours} />

            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={locationSetting} setOpen={setLocationSetting} show={locationSetting} setShow={setLocationSetting} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Geo Location Fenching</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={() => { locationFenchingShow() }}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className='pb-3'>
              {locationSetting && <GeoLocation data={geolocation} close={() => locationFenchingShow()} />}
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal >

      <MDBModal open={DigitalWaver} setOpen={setDigitalWaver} show={DigitalWaver} setShow={setDigitalWaver} tabIndex='-1'>
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Digital Waiver Form</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={() => { DigitalWaverShow(); }}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className='pb-3'>
              {DigitalWaver && <WaiverSettings toggleShow={DigitalWaverShow} data={WaiverForm} onSave={saveWaiverSettings} onbacktoStaff={onbacktoStaff} />}
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={QRDigitalWaver} setOpen={setQRDigitalWaver} show={QRDigitalWaver} setShow={setQRDigitalWaver} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{WaiverForm.title ? WaiverForm.title : "Digital Waiver Form"}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={QRDigitalWaverShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {/* <div className="d-flex align-items-center justify-content-center pb-3">
              <h4>{WaiverForm.title} QR Code</h4>
            </div> */}

              <div ref={modalBodyRef}>
                <center>
                  <div>
                    <QRCodeSVG style={{ width: '300px', height: '300px' }} value={link} />
                  </div>
                </center>
              </div>
              <div className="mob-flex float-end mt-4 no-wrapbtns">
                <MDBBtn className="ms-2" onClick={handleCopyLink}>
                  Copy Link
                </MDBBtn>
                <MDBBtn className="ms-2" onClick={handlePrintPDF}>
                  Print
                </MDBBtn>
                <MDBBtn className="ms-2" onClick={setQRDigitalWaverconfirmation}>
                  Regenerate Link
                </MDBBtn>

                <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={QRDigitalWaverShow}>
                  Close
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={QRDigitalWaverconfirmation} setOpen={setQRDigitalWaverconfirmation} show={QRDigitalWaverconfirmation} setShow={setQRDigitalWaverconfirmation} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{WaiverForm.title ? WaiverForm.title : "Digital Waiver Form"}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={QRDigitalWaverconfirmationShow}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {/* <div className="d-flex align-items-center justify-content-center pb-3">
              <h4>{WaiverForm.title} QR Code</h4>
            </div> */}

              <div ref={modalBodyRef}>
                <center>
                  <div>By regenerating the <strong>link</strong>, the existing one sent to multiple members will be replaced and may no longer function. <br />Are you certain you wish to proceed with <strong>Regenerating</strong> the link?
                  </div>
                </center>
              </div>
              <div className="mob-flex float-end mt-4">
                <MDBBtn className="ms-2" onClick={reGenerateLink}>
                  Regenerate Link
                </MDBBtn>

                <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={QRDigitalWaverconfirmationShow}>
                  Close
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal
        show={MultiGymSettingsOpen}
        setShow={setMultiGymSettingsOpen}
        tabIndex='-1'
      >        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Check in Settings</MDBModalTitle>
              <MDBBtn
                className='btn-close'
                color='none'
                onClick={multiGymSettingsShow}
              ></MDBBtn>            </MDBModalHeader>
            <MDBModalBody >
              <MultiGymSettings
                gyms={gyms}
                globalPlans={globalPlans}
                savedSettings={savedSettings}
                onClose={multiGymSettingsShow}
              />            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal >

      <MDBModal open={eaRegenConfirm} setOpen={setEaRegenConfirm} show={eaRegenConfirm} setShow={setEaRegenConfirm} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Regenerate Device Key</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={() => setEaRegenConfirm(false)} />
            </MDBModalHeader>
            <MDBModalBody>
              <p>
                Regenerating the key will <strong>invalidate the current key</strong>. Your EA server will stop syncing until you update its config with the new key.
              </p>
              <p className="mb-0">Are you sure you want to proceed?</p>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color='danger' onClick={handleEARegenerate}>
                Yes, Regenerate
              </MDBBtn>
              <button className="ripple ripple-surface btn btn-secondary ms-2" onClick={() => setEaRegenConfirm(false)}>
                Cancel
              </button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={pinelabsModal} setOpen={setPinelabsModal} show={pinelabsModal} setShow={setPinelabsModal} tabIndex='-1'>
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Pine Labs POS Devices</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={pinelabsModalShow} />
            </MDBModalHeader>

            <MDBModalBody>
              {/* Header row: device count + Add button */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <span className="text-muted" style={{ fontSize: 13 }}>
                  {pinelabsForm.length === 0
                    ? 'No devices configured'
                    : `${pinelabsForm.length} device${pinelabsForm.length > 1 ? 's' : ''}`}
                </span>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => setPinelabsForm(prev => [...prev, emptyDevice()])}
                >
                  + Add Device
                </button>
              </div>

              {/* Empty state */}
              {pinelabsForm.length === 0 && (
                <div className="text-center py-4 text-muted" style={{ border: '1px dashed #ccc', borderRadius: 6 }}>
                  <MDBIcon fas icon="cash-register" className="mb-2" style={{ fontSize: 28 }} />
                  <div style={{ fontSize: 13 }}>No POS devices yet. Click "+ Add Device" to get started.</div>
                </div>
              )}

              {/* Device cards */}
              {pinelabsForm.map((device, i) => (
                <div key={i} className="border rounded mb-3" style={{ overflow: 'hidden' }}>

                  {/* Card header */}
                  <div className="d-flex align-items-center justify-content-between px-3 py-2"
                    style={{ background: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                    <span className="fw-600" style={{ fontSize: 13 }}>
                      {device.deviceName ? device.deviceName : `Device ${i + 1}`}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => setPinelabsForm(prev => prev.filter((_, idx) => idx !== i))}
                    >
                      Remove
                    </button>
                  </div>

                  {/* Fields */}
                  <div className="p-3">
                    {/* Device Name — full width */}
                    <div className="mb-3">
                      <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Device Name</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        placeholder="e.g. Counter 1, Reception"
                        value={device.deviceName}
                        onChange={(e) => updatePinelabsDevice(i, 'deviceName', e.target.value)}
                      />
                    </div>

                    {/* 2-column grid */}
                    <div className="row g-3">
                      <div className="col-6">
                        <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Merchant ID</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Merchant ID"
                          value={device.merchantId}
                          onChange={(e) => updatePinelabsDevice(i, 'merchantId', e.target.value)}
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Client ID</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Client ID"
                          value={device.clientId}
                          onChange={(e) => updatePinelabsDevice(i, 'clientId', e.target.value)}
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Store ID</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Store ID"
                          value={device.storeId}
                          onChange={(e) => updatePinelabsDevice(i, 'storeId', e.target.value)}
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Device Number</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="IMEI / Device No."
                          value={device.deviceNumber}
                          onChange={(e) => updatePinelabsDevice(i, 'deviceNumber', e.target.value)}
                        />
                      </div>
                      <div className="col-12">
                        <label className="form-label mb-1" style={{ fontSize: 13, fontWeight: 600 }}>Security Token</label>
                        <div className="input-group input-group-sm">
                          <input
                            className="form-control"
                            type={device._showToken ? 'text' : 'password'}
                            placeholder="Security Token"
                            value={device.securityToken}
                            onChange={(e) => updatePinelabsDevice(i, 'securityToken', e.target.value)}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => updatePinelabsDevice(i, '_showToken', !device._showToken)}
                          >
                            <MDBIcon fas icon={device._showToken ? 'eye-slash' : 'eye'} />
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              ))}
            </MDBModalBody>

            <MDBModalFooter>
              <div className="d-flex gap-2">
                <MDBBtn color='primary' onClick={handlePinelabsSave} disabled={pinelabsSaving}>
                  {pinelabsSaving ? 'Saving...' : 'Save Devices'}
                </MDBBtn>
                <button className="ripple ripple-surface btn btn-secondary" onClick={pinelabsModalShow}>
                  Cancel
                </button>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBAlert
        color='success'
        autohide
        position='top-right'
        delay={2000}
        appendToBody
        open={copyLink}
        onClose={() => setcopyLink(false)}
      >Link copied to clipboard!
      </MDBAlert>



      <MDBAlert
        color={Error2.includes("ailed") ? "danger" : "success"}
        autohide
        position='top-right'
        delay={3000}
        appendToBody
        open={Error2 !== ""}
        onClose={() => setError2("")}
      >
        {Error2}
      </MDBAlert>
    </>
  );
};

export default BusinessInfo;